import { Document } from '../../jurisdiction/jurisdiction.domain';
import { RegistrationOfEnergyProducerApplicationDocumentTypes } from './enums/regepDocumentTypes';

export class CommissioningOfEnergyProducer {
  commissioning_date?: Date;
  commissioning_date_unknown: boolean;
  confirm_commissioning_corresponds_to_technical_data: boolean;
  photo_documentation_of_installed_generators_and_converters: Document = new Document(
    RegistrationOfEnergyProducerApplicationDocumentTypes.PhotoDocumentationOfInstalledGeneratorsAndConverters
  );
  request_for_meter_mounting: Document = new Document(
    RegistrationOfEnergyProducerApplicationDocumentTypes.PhotoDocumentationOfInstalledGeneratorsAndConverters
  );
}
